<template>
  <yxt-collapse
    v-model="activeNames"
    class="width100 skill_table_container"
  >
    <yxt-collapse-item
      v-for="classification in skillCatalogs"
      :key="classification.id"
      :name="classification.name"
      class="width100 mb24 customized-collapse"
    >
      <template slot="title">
        <yxt-blockhead
          class="skill_table_item_title ml24"
          :title="classification.name"
          type="special"
          :cutline="false"
        />
      </template>
      <yxt-table
        :ref="`radarTable_${classification.id}`"
        :data="classification[classifyProps]"
        class="table-fix-style mt16"
        row-key="id"
        :tree-props="{ children: childKey }"
        @row-click="handleRowClick"
      >
        <yxt-table-column
          :label="$t('pc_gwnl_global_lbl_skillName')"
          prop="name"
          show-overflow-tooltip
        />
        <yxt-table-column
          :label="$t('pc_gwnl_global_lbl_skillDescription')"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.skill ? row.skill.description : '' }}
          </template>
        </yxt-table-column>
        <template v-if="isShowSkillLevel">
          <yxt-table-column
            :label="$t('pc_gwnl_standard_grade')"
            prop="standardLevel"
          >
            <template slot-scope="{ row }">
              {{ showLevelName(row) || row.standardLevelName || row.standLevelName || row.standardLevelStr }}
            </template>
          </yxt-table-column>
          <template v-if="enableExcellentLevel">
            <yxt-table-column
              :label="$t('pc_gwnl_jq_excellent_grade')"
              prop="excellentLevel"
            >
              <template slot-scope="{ row }">
                {{ showExcellentLevelName(row) || row.combExcellentLevelName }}
              </template>
            </yxt-table-column>
          </template>
          <yxt-table-column
            :label="$t('pc_gwnl_global_lbl_behavior')"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              {{ showSkillDesc(row) || (row.skill && row.skill.skillBehavior) }}
            </template>
          </yxt-table-column>
        </template>
        <yxt-table-column
          v-if="enableWeightSwitch === 1"
          :label="('pc_gwnl_eval_lbl_weight').d('权重')"
          prop="weight"
        >
          <template slot-scope="{ row }">
            <div :class="{'ml10': typeof row[childKey] === 'undefined'}">
              {{ row.weight.toFixed(1) }}%
            </div>
          </template>
        </yxt-table-column>
      </yxt-table>
    </yxt-collapse-item>
  </yxt-collapse>
</template>
<script>
export default {
  filters: {},
  props: {
    // 标记二级能力数组的字段名
    childKey: {
      type: String,
      default: 'jqSkillMaps'
    },
    /**
     * 分类字段
     */
    classifyProps: {
      type: String,
      default: 'skillModelClassifications'
    },
    skillCatalogs: {
      default: () => {
        return [];
      },
      type: Array
    },
    enableWeightSwitch: {
      type: Number,
      default: 0
    },
    enableExcellentLevel: {
      type: Number,
      default: 0
    },
    isShowSkillLevel: {
      type: [Boolean, Number],
      default: true
    }
  },
  data() {
    return {
      activeNames: this.skillCatalogs.map((item) => item.name)
    };
  },
  methods: {
    handleRowClick(row) {
      this.$refs[`radarTable_${row.parentId}`] &&
      this.$refs[`radarTable_${row.parentId}`][0] &&
      this.$refs[`radarTable_${row.parentId}`][0].toggleRowExpansion(row);
    },
    showLevelName(row) {
      if (row && row.skill && row.skill.skillLevelMaps) {
        const skillLevel = row.skill.skillLevelMaps.find((item) => item.level === Number(row.standardLevel));
        return skillLevel.name || '';
      } else {
        return '';
      }
    },
    showExcellentLevelName(row) {
      if (row && row.skill && row.skill.skillLevelMaps) {
        const skillLevel = row.skill.skillLevelMaps.find((item) => item.level === Number(row.excellentLevel));
        return skillLevel.name || '';
      } else {
        return '';
      }
    },
    showSkillDesc(row) {
      if (row && row.skill && row.skill.skillLevelMaps) {
        const skillLevel = row.skill.skillLevelMaps.find((item) => item.level === Number(row.standardLevel));
        return skillLevel.behavior || '';
      } else {
        return '';
      }
    }
  }
};
</script>
<style lang="scss" scoped>

.width100 {
  width: 100%;
}
.customized-collapse {
  ::v-deep .yxt-collapse-item__content {
    padding-left: 0;
  }
}

.skill_table_container {
  border: none;

  ::v-deep .yxt-collapse-item__header {
    height: 52px;
    background: linear-gradient(90deg, #f9faff 0%, rgba(255, 255, 255, 0) 100%);
    border: none;
    border-radius: 6px;
    transition: none;
  }

  ::v-deep .yxt-collapse-item__wrap {
    border: none;
  }

  ::v-deep .yxt-collapse-item__content {
    padding-bottom: 0;
  }

  .skill_table_item_title {
    height: 52px;
    background: transparent;
  }
}
</style>
